/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import startOfDay from "date-fns/start_of_day";
import startOfYear from "date-fns/start_of_year";
import isValid from "date-fns/is_valid";
import isBefore from "date-fns/is_before";
import format from "date-fns/format";

export function compactFormat(dt) {
  const d = new Date(dt);
  if (!isValid(d)) {
    return "";
  }
  const now = new Date();
  const sod = startOfDay(now);
  const soy = startOfYear(now);
  if (isBefore(d, soy)) {
    return format(d, "YY-MM-DD HH:mm:ss");
  } else if (isBefore(d, sod)) {
    return format(d, "MM-DD HH:mm:ss");
  }
  return format(d, "HH:mm:ss");
}

export const formatTime = (timestamp, withSecond = false) => {
  const today = new Date();
  if (_.isNil(timestamp)) return "";

  const timeFormat = withSecond ? "HH:mm:ss" : "HH:mm";
  if (isSameYear(today, timestamp)) {
    return format(timestamp, `MM-DD ${timeFormat}`);
  }
  return format(timestamp, `YYYY-MM-DD ${timeFormat}`);
};




// WEBPACK FOOTER //
// ./src/utils/DateTimeUtils.js